module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_sapporo@2x-47105ef39285ddb0c52eee1e2a2c6f9b.webp";